export class AgeYears {
  readonly value: number;

  constructor(value: number) {
    if (!Number.isInteger(value)) {
      throw new Error(`AgeYears must be an integer, got ${value}`);
    }
    this.value = value;
  }

  plus(n: number): AgeYears {
    return new AgeYears(this.value + n);
  }

  minus(n: number): AgeYears {
    return new AgeYears(this.value - n);
  }

  difference(other: AgeYears): number {
    return this.value - other.value;
  }

  equals(other: AgeYears): boolean {
    return this.value === other.value;
  }

  toString(): string {
    return `${this.value} years`;
  }
}